import {useAuthAxios} from 'hooks/api/useAuthAxios'

export const useStartProcedureStatus = () => {
  const authAxios = useAuthAxios()

  return async (employeeId: string, procedureType: string, dateOn: string, status = 'draft') => {
    return authAxios.post('/api/procedure_statuses', {
      employee_id: employeeId,
      procedure_type: procedureType,
      date_on: dateOn,
      status,
    })
  }
}
